import { StateCreator } from "zustand";

export enum ECardSMSFormState {
  initial,
  validating,
  validated,
  submitting,
  submitted,
}

export interface ICardSMSFormSlice {
  smsCode: string;
  smsFormState: ECardSMSFormState;
  errorMessage: string;
  setSMSCode: (smsCode: string) => void;
  clearSMSForm: () => void;
  setSMSFormState: (state: ECardSMSFormState) => void;
  setErrorMessage: (errorMessage: string) => void;
}

/**
 * Contains all information about card sms form.
 */
export const cardSmsFormSliceCreator: StateCreator<ICardSMSFormSlice> = set => ({
  smsCode: "",
  errorMessage: "",
  smsFormState: ECardSMSFormState.initial,
  setSMSCode: (smsCode) => {
    set(() => ({
      smsCode: smsCode.replace(/\D|.{5,}/ig, ""),
    }));
  },
  clearSMSForm: () => {
    set(() => ({
      smsCode: "",
      smsFormState: ECardSMSFormState.initial,
      errorMessage: "",
    }));
  },
  setSMSFormState: (state: ECardSMSFormState) => {
    set(() => ({ smsFormState: state }));
  },
  setErrorMessage: (message) => {
    set(() => ({ errorMessage: message }));
  },
});
